import { render, staticRenderFns } from "./HelpBox.vue?vue&type=template&id=5cf7c209&"
import script from "./HelpBox.vue?vue&type=script&lang=js&"
export * from "./HelpBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports